import React from 'react';
import {
    Spinner
} from '@cloudscape-design/components';
import './RecommendationsGrid.css';

const RecommendationsGrid = ({ recommendations, loading = false, compact = false }) => {
    if (loading) {
        return (
            <div className="loading-container-compact">
                <Spinner size="large" />
            </div>
        );
    }

    if (!recommendations || recommendations.trim() === '') {
        return (
            <div className="no-recommendations-compact">
                No recommendations available
            </div>
        );
    }

    // Parse recommendations into structured items
    // Expected format:
    // 1. Skill Area
    // Observation: ...
    // Suggestion: ...
    const parseRecommendations = (text) => {
        const items = [];
        const sections = text.split(/(?=\d+\.\s)/).filter(s => s.trim());
        
        sections.forEach(section => {
            const lines = section.split('\n').filter(l => l.trim());
            if (lines.length === 0) return;
            
            const titleMatch = lines[0].match(/^(\d+)\.\s*(.+)$/);
            if (!titleMatch) return;
            
            const number = titleMatch[1];
            const title = titleMatch[2];
            
            let observation = '';
            let suggestion = '';
            
            lines.slice(1).forEach(line => {
                if (line.startsWith('Observation:')) {
                    observation = line.replace('Observation:', '').trim();
                } else if (line.startsWith('Suggestion:')) {
                    suggestion = line.replace('Suggestion:', '').trim();
                } else if (observation && !suggestion) {
                    observation += ' ' + line.trim();
                } else if (suggestion) {
                    suggestion += ' ' + line.trim();
                }
            });
            
            items.push({ number, title, observation, suggestion });
        });
        
        return items;
    };

    const recommendationItems = parseRecommendations(recommendations);

    return (
        <div className="recommendations-compact">
            {recommendationItems.length > 0 ? (
                <div className="recommendations-list">
                    {recommendationItems.map((rec, index) => (
                        <div key={index} className="recommendation-item-structured">
                            <div className="recommendation-header">
                                <span className="recommendation-number">{rec.number}.</span>
                                <span className="recommendation-title">{rec.title}</span>
                            </div>
                            {rec.observation && (
                                <div className="recommendation-section">
                                    <span className="recommendation-label">Observation:</span>
                                    <span className="recommendation-content">{rec.observation}</span>
                                </div>
                            )}
                            {rec.suggestion && (
                                <div className="recommendation-section">
                                    <span className="recommendation-label">Suggestion:</span>
                                    <span className="recommendation-content">{rec.suggestion}</span>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            ) : (
                <div className="no-recommendations-compact">
                    No recommendations available
                </div>
            )}
        </div>
    );
};

export default RecommendationsGrid;
